<ui-section>
  <ui-block>
    <ui-panel
      width="fill"
      class="program-pack-workspace"
      panelTitle="Program Packs"
      title="Program Packs"
      subtitle="Inspect the active jurisdiction/program pack binding and preview resolved context (read-only)."
    >
      <div class="workspace-toolbar">
        <div class="workspace-form">
          <ui-form
            #previewForm
            [config]="previewFormConfig"
            [(formValues)]="previewFormValues"
            [disabled]="isResolving()"
            [showFormErrors]="true"
          ></ui-form>

          <ui-button-group
            class="workspace-actions"
            [buttonsConfig]="previewActionButtons()"
            (buttonClick)="onPreviewActionButtonClick($event)"
          ></ui-button-group>
        </div>

        <p class="read-only-note" data-testid="read-only-note">
          This workspace is diagnostic and read-only. Publish and rollback are handled by the governed change-set
          workflow and are not available here.
        </p>
      </div>

      <div *ngIf="isResolving()" class="state loading" data-testid="loading-state">
        Resolving program pack
      </div>

      <div *ngIf="!isResolving() && !hasLoaded()" class="state" data-testid="initial-state">
        No program pack resolved yet.
      </div>

      <ui-panel
        *ngIf="!isResolving() && resolutionResult() as result"
        width="fill"
        class="workspace-section"
        panelTitle="Pack Selection"
        title="Pack Selection"
        data-testid="pack-selection-section"
      >
        <span [class]="'badge ' + result.state">{{ result.state }}</span>
        <p *ngIf="result.state !== 'resolved'" class="message">{{ formatMessage(result) }}</p>

        <ng-container *ngIf="pack() as resolved">
          <dl class="detail-list">
            <div>
              <dt>Selection Source</dt>
              <dd>{{ selection()?.sourceCode ?? "none" }}</dd>
            </div>
            <div>
              <dt>Jurisdiction / Program</dt>
              <dd>{{ formatSelectionScope() }}</dd>
            </div>
            <div>
              <dt>Effective Status</dt>
              <dd>{{ resolved.resolution.disposition }} ({{ resolved.resolution.reasonCode ?? "n/a" }})</dd>
            </div>
            <div>
              <dt>Matched Bindings</dt>
              <dd>{{ resolved.resolution.matchedBindingCount }}</dd>
            </div>
          </dl>
        </ng-container>
      </ui-panel>

      <ui-panel
        *ngIf="configurationVersion() as version"
        width="fill"
        class="workspace-section"
        panelTitle="Active Binding"
        title="Active Binding"
        data-testid="active-binding-section"
      >
        <dl class="detail-list">
          <div>
            <dt>Configuration</dt>
            <dd>{{ version.configurationCode }} / {{ version.versionCode }}</dd>
          </div>
          <div>
            <dt>Display Name</dt>
            <dd>{{ version.displayName ?? "n/a" }}</dd>
          </div>
          <div>
            <dt>Matched Scope</dt>
            <dd>{{ version.matchedScopeTypeCode }}{{ version.matchedScopeKey ? " / " + version.matchedScopeKey : "" }}</dd>
          </div>
          <div>
            <dt>Effective Window</dt>
            <dd>{{ formatEffectiveWindow() }}</dd>
          </div>
        </dl>
      </ui-panel>

      <ui-panel
        *ngIf="pack()"
        width="fill"
        class="workspace-section"
        panelTitle="Scope Precedence"
        title="Scope Precedence"
        [totalCount]="scopePrecedence().length"
        data-testid="scope-precedence-section"
      >
        <p *ngIf="scopePrecedence().length === 0" class="message">No scope precedence resolved.</p>
        <ui-grid
          *ngIf="scopePrecedence().length > 0"
          width="fill"
          containerClass="no-panel"
          [rowData]="scopePrecedence()"
          [columnDefs]="scopePrecedenceColumnDefs"
          [showPanelHeader]="false"
          [showBlankRowsOnLastPage]="true"
        ></ui-grid>
      </ui-panel>

      <ui-panel
        *ngIf="resolutionTrace().length > 0"
        width="fill"
        class="workspace-section"
        panelTitle="Resolution Trace"
        title="Resolution Trace"
        [totalCount]="resolutionTrace().length"
        data-testid="resolution-trace-section"
      >
        <ui-grid
          width="fill"
          containerClass="no-panel"
          [rowData]="resolutionTrace()"
          [columnDefs]="resolutionTraceColumnDefs"
          [showPanelHeader]="false"
          [showBlankRowsOnLastPage]="true"
        ></ui-grid>
      </ui-panel>

      <ui-panel
        *ngIf="pack()"
        width="fill"
        class="workspace-section"
        panelTitle="Resolved Context"
        title="Resolved Context"
        subtitle="Terminology and label context resolved for the supplied preview, without changing production data."
        [totalCount]="contextEntries().length"
        data-testid="resolved-context-section"
      >
        <p *ngIf="contextEntries().length === 0" class="message">No resolved context returned.</p>
        <ui-grid
          *ngIf="contextEntries().length > 0"
          width="fill"
          containerClass="no-panel"
          [rowData]="contextEntries()"
          [columnDefs]="contextColumnDefs"
          [showPanelHeader]="false"
          [showBlankRowsOnLastPage]="true"
        ></ui-grid>
      </ui-panel>
    </ui-panel>
  </ui-block>
</ui-section>
